// extracted by mini-css-extract-plugin
export default {"projectMainInfo":"projectDashboard_projectMainInfo__0TI9X","projectImage":"projectDashboard_projectImage__1aRQA"};